import request from "@/CommonDP/utils/request";
export default {
  // *****修改的批注问题相关接口****

  // 创建批注字典列表
  getNotationDic(prjID, fileId) {
    return request.get(`/drawing/dic?prjId=${prjID}&fileId=${fileId}`)
  },
  // 高级筛选字典
  getFilterDic(prjId) {
    return request.get(`/drawing/getFilterConditions?prjId=${prjId}`)
  },
  // 添加批注
  notationAdd(params) {
    return request.post("/drawing/add", params)
  },
  // 修改状态
  drawingannotationupdateStatus(data) {
    return request.post("/drawing/status/update", data)
  },
  // 批量修改问题状态
  DrawingQuestionStatusBatchEdit(data) {
    return request.post( "/drawing/status/batchUpdate", data );
  },
  //导出excel
  drawingDrawingQuesExport(params1) {
    return request({
        responseType: "blob",
        url: "/drawing/export",
        method: "post",
        data: params1
    });
  },
  //筛选条件的数据
  batchUpdatecount(data) {
    return request.post( "/drawing/status/batchUpdate/count", data );
  },
  getDicList(prjId) {
    return request.get('/drawing/dic?prjId=' + prjId);
  },
  getDrawingQuestionDetailsLc(questionId, userId, flowInstanceId, shareId) {
    return request.get(`/lc/drawing-annotation/getById?id=${questionId}&userId=${userId}&flowInstanceId=${flowInstanceId || ''}&shareId=${shareId || ''}`)
  },
  notationAdd(params) {
    return request.post("/drawing/add", params)
      .then(res => res);
  },
  getFilterDic(prjId, userId, flowInstanceId) {
    return request.get(`/drawing/getFilterConditions?prjId=${prjId}&userId=${userId}&flowInstanceId=${flowInstanceId || ''}`)
  },
  // 高级筛选字典(批注列表)
  getFilterDicCheckLabel(params) {
    return request.post(`/drawing/getFilterConditions`, params)
  },
  prjQuestionStatus(prjId) {
    return request.get(`/count/prjQuestionStatus?prjId=${prjId}`)
  },
  prjSpecQuestion(prjId,category) {
    return request.get(`/count/prjSpecQuestion?prjId=${prjId}&category=${category}`)
  },
  prjDrawingReviewers(prjId) {
    return request.get(`/count/prjDrawingReviewers?prjId=${prjId}`)
  },

  //异步导出
  exportExcel(params) {
    return request.post("/drawing/async/exportExcel", params);
  },
  getExportStatus(excelId) {
    return request.get(`/drawing/getExportStatus/${excelId}`)
  },
  downloadExce(excelId) {
    return request.get(`/drawing/downloadExcel/${excelId}`, {
      responseType: 'blob'
    })
  },
};